import React from 'react';

const SvgCna = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CNA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CNA_svg__b" fill="#fff">
        <use xlinkHref="#CNA_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CNA_svg__a" />
      <path fill="#19BFBF" mask="url(#CNA_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M13.481 14.963l-.296-.592-.37-.742a.596.596 0 0 0-.482-.296.91.91 0 0 1-.57-.236L9.57 10.903a.912.912 0 0 1-.237-.573v-.66a.924.924 0 0 0-.232-.569l-.869-.869a1.405 1.405 0 0 1-.314-.559L7.415 5.66a.683.683 0 0 0-.394-.43l-1.375-.46a5.602 5.602 0 0 1-.609-.251l-.741-.371A.58.58 0 0 1 4 3.664v-.66c0-.187.143-.337.336-.337h.66c.187 0 .441.104.578.24l.185.186a.92.92 0 0 0 .577.24h.66c.187 0 .441-.104.578-.24l.185-.186a.918.918 0 0 1 .568-.24h2.013c.18 0 .46.066.623.148l.741.37c.164.082.439.148.632.148h.66c.187 0 .47-.066.633-.148l.742-.37a1.64 1.64 0 0 1 .623-.148h2.012c.18 0 .327.142.327.336v.66a.331.331 0 0 1-.336.337h-.66a.34.34 0 0 0-.337.33v1.34c0 .182.133.396.296.478l.741.37c.164.082.296-.008.296-.182v-1.34c0-.181.157-.33.33-.33h1.34c.182 0 .33.155.33.334 0 .184.157.333.33.333h1.34c.182 0 .33.143.33.337v.66c0 .186-.048.48-.104.65l-.458 1.374c-.058.173-.212.42-.334.542l-1.54 1.541a2.419 2.419 0 0 0-.378.526l-.371.741a1.642 1.642 0 0 0-.148.632v.66a.338.338 0 0 1-.333.337.588.588 0 0 1-.482-.296l-.37-.741a.598.598 0 0 0-.479-.296h-1.34a.586.586 0 0 0-.477.296l-.371.741a.746.746 0 0 0 0 .592l.37.742a.58.58 0 0 0 .485.296h.66c.186 0 .442.104.57.232l.868.869a.903.903 0 0 1 .232.568v.66a.331.331 0 0 1-.336.337h-.66a.591.591 0 0 1-.485-.296l-.37-.741a.58.58 0 0 0-.485-.296h-.66a.591.591 0 0 1-.485-.296l-.37-.741z"
        fill="#FFF"
        mask="url(#CNA_svg__b)"
      />
    </g>
  </svg>
);

export default SvgCna;
